module.exports = __webpack_public_path__ + "img/bookBeauty.7f30fa61.png";